import React from 'react';

import * as util from '#packages/util';

import { AppManager } from '@wix/editor-platform-host-integration/ui';
import type {
  AppManagerStateProps,
  AppManagerDispatchProps,
} from '@wix/editor-platform-host-integration/ui';

import { mapStateToProps, mapDispatchToProps } from './MyBusinessPanel.mapper';
import { withPanelFrame } from './panelFrame/PanelFrame';

export type MyBusinessPanelProps = AppManagerStateProps &
  AppManagerDispatchProps;

const MyBusinessPanel: React.FC<MyBusinessPanelProps> = (props) => {
  return <AppManager {...props} />;
};

export default util.hoc.connect(
  util.hoc.STORES.EDITOR_API,
  mapStateToProps,
  mapDispatchToProps,
)(withPanelFrame(MyBusinessPanel));
